import { sumBy, effectiveBalance } from "@/lib/format";

const tile = (label, value, sub, idx) => (
  <div
    key={label}
    className="card p-5 rise-in"
    style={{ animationDelay: `${idx * 80}ms` }}
    data-testid={`totals-tile-${label.replace(/\s+/g, "-").toLowerCase()}`}
  >
    <div className="section-eyebrow">{label}</div>
    <div className="font-display tabular text-[26px] font-extrabold tracking-tight mt-2">
      {value}
    </div>
    <div className="text-[12px] text-neutral-500 mt-1 truncate">{sub}</div>
  </div>
);

export default function TotalsBar({ programs, credits, awards = [] }) {
  // Pooled balances (e.g. United Miles Pooling — pool owner) REPLACE the
  // individual balance, not stack on top of it. effectiveBalance() picks the
  // right number per program so totals match what the cards show.
  const hotelTotal = sumBy(
    programs.filter((p) => p.category === "hotel"),
    effectiveBalance
  );
  const airlineTotal = sumBy(
    programs.filter((p) => p.category === "airline" && effectiveBalance(p) > 0),
    effectiveBalance
  );
  const transferableTotal = sumBy(
    programs.filter((p) => p.transferable),
    effectiveBalance
  );
  // Sum of "$" values from credits + AW-sourced awards. Skip expired.
  const today = new Date().toISOString().slice(0, 10);
  const grabDollars = (s) => {
    if (!s) return 0;
    const m = String(s).match(/\$([\d,]+(?:\.\d+)?)/);
    return m ? Number(m[1].replace(/,/g, "")) : 0;
  };
  const cashCredits =
    credits.reduce((acc, c) => {
      const exp = c.expires_at;
      if (exp && exp !== "no expiry" && exp < today) return acc;
      return acc + grabDollars(c.value);
    }, 0) +
    awards.reduce((acc, a) => {
      const exp = a.expires_at;
      if (exp && exp !== "no expiry" && exp < today) return acc;
      return acc + grabDollars(a.notes);
    }, 0);

  const cashItemsCount =
    credits.filter((c) => grabDollars(c.value) > 0).length +
    awards.filter((a) => grabDollars(a.notes) > 0).length;

  const fmt = (n) => n.toLocaleString("en-US");

  const hotelSub = programs
    .filter((p) => p.category === "hotel" && effectiveBalance(p) > 0)
    .map((p) => p.name.split(" ")[0])
    .slice(0, 3)
    .join(" · ");

  const airSub = programs
    .filter((p) => p.category === "airline" && effectiveBalance(p) > 0)
    .map((p) => p.name.split(" ")[0])
    .slice(0, 3)
    .join(" · ");

  const xferSub = programs
    .filter((p) => p.transferable && effectiveBalance(p) > 0)
    .map((p) => p.name.split(" ")[0])
    .slice(0, 3)
    .join(" + ");

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {tile("Hotel points", fmt(hotelTotal), hotelSub || "—", 0)}
      {tile("Airline miles", fmt(airlineTotal), airSub || "—", 1)}
      {tile("Transferable", fmt(transferableTotal), xferSub || "—", 2)}
      {tile(
        "Cash & credits",
        cashCredits ? `$${fmt(cashCredits)}` : "$0",
        `${cashItemsCount} item${cashItemsCount === 1 ? "" : "s"} on file`,
        3
      )}
    </div>
  );
}
